<nz-spin [nzSpinning]="processingScan()" nzSize="small">
    <pf-input
        [pfStyle]="inputStyle()"
        [label]="label()"
        inputType="barcode"
        [control]="barcodeControl"
        [pfDisabled]="disabled() || processingScan()"
        (keyup.enter)="onBarcodeScanned($event)"
        (focusout)="onBlurScan($event)"
        (paste)="onPaste($event)"></pf-input>
</nz-spin>
